import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private AzureFunction = `https://vdu-token-generator.azurewebsites.net/api/`;
  private Membership = `lDY2DQkbBj7KTh4jJbbWv12ZFnLbcBHAl2BRWNpgUm0IAzFuxGpWfA%3D%3D`;
  private Dynamics = `Np5qEiKiJgP75C4QVVwguiGoJJOzLhLK4nq12ZsIwIXDAzFuq-0Ksw%3D%3D`;
  private messageSource = new BehaviorSubject([]); // For Selected_Sessions IDS
  private nameSource = new BehaviorSubject([]); // For Selected_Sessions Names
  private emailSource = new BehaviorSubject('');
  private groupSource = new BehaviorSubject('');

  currentMessage = this.messageSource.asObservable();
  currentName = this.nameSource.asObservable();
  currentEmail = this.emailSource.asObservable();
  currentGroup = this.groupSource.asObservable();

  constructor(private http: HttpClient) { }

  // Update Sessions Ids Using Observable
  changeMessage(message: []) {
    this.messageSource.next(message)
  }

  // Update Sessions Names Using Observable
  changeName(message: []) {
    this.nameSource.next(message)
  }

  changeEmail(message: string){
    this.emailSource.next(message);
  }
  
  changeGroup(message: string){
    this.groupSource.next(message);
  }

  getUserDetailfromD365(payload: any){
    const url = `${this.AzureFunction}dynamicscrm?code=${this.Dynamics}&name=member`;
    return this.http.post(url, payload);
  }

  getPotentialUserDetailFromD365(payload: any){
    const url = `${this.AzureFunction}dynamicscrm?code=${this.Dynamics}&name=potentialmember`;
    return this.http.post(url, payload);
  }

  getUserRegistrationDetails(payload: any){
    // console.log("getUserRegistrationDetails");
    const url = `${environment.apiEndpoint_PROXY}/?mode=event-registrations&eventId=${payload.readableEventId}&email=${payload.email}`;
    return this.http.get(url);
  }

  getRegisteredUsers(payload: any){
    const url = `${this.AzureFunction}dynamicscrm?code=${this.Dynamics}&name=registeredusers`;
    return this.http.post(url, payload);
  }

  postUserRegistrationForm(payload: any){
    const url = `${this.AzureFunction}membership?code=${this.Membership}&name=registration`;
    return this.http.post(url, payload);
  }

  postUserConfirmation(payload: any){
    const url = `${this.AzureFunction}membership?code=${this.Membership}&name=confirmation`;
    return this.http.post(url, payload);
  }

  postUserContact(payload: any){
    const url = `${this.AzureFunction}membership?code=${this.Membership}&name=creation`;
    return this.http.post(url, payload);
  }

}
